var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowChartDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.9858 16.9139L6.12445 5.04227C5.8253 4.74286 5.34 4.74286 5.04085 5.04227V5.04227C4.74207 5.34132 4.74207 5.82588 5.04085 6.12493L16.8899 17.9843H12.758C12.3394 17.9843 12.0001 18.3236 12.0001 18.7422V18.7422C12.0001 19.1607 12.3394 19.5 12.758 19.5H18.7501C19.1643 19.5 19.5001 19.1642 19.5001 18.75V12.7638C19.5001 12.3456 19.1611 12.0066 18.7429 12.0066V12.0066C18.3247 12.0066 17.9858 12.3456 17.9858 12.7638V16.9139Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowChartDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-chart-down.053d7521968186dbc379d729c156d1bb.svg";